import React, { useState, useEffect } from "react";
import CapitaliseWords from "../../../../shared/utils/CapitaliseWords";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  IconButton,
  FormHelperText,
  FormControl,
} from "@mui/material";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import CustomInput from "../../../../shared/utils/Input";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import axios from "axios";
import { Chip } from "@mui/material";
import GlobalButton from "../../../../shared/utils/GlobalButton";

const PaymentDialog = ({ open, onClose, selectedRow, userListData }) => {
  const serverURL = process.env.REACT_APP_URL;

  const selectPaymentMethod = [
    { name: "RTGS" },
    { name: "IPMS" },
    { name: "UPI" },
    { name: "CASH" },
  ];
  const [data, setData] = useState({
    amount: selectedRow?.amountPaid || "",
    utr: selectedRow?.transactionId || "",
    date: null,
    paymentMethod: selectedRow?.paymentMethod || "",
  });
  const [isamount, setIsamount] = useState(true);
  const [errors, setErrors] = useState({}); // <-- Added error state
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target; // Correct way to access name and value
    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!data.amount) newErrors.amount = "Amount is required";
    if (!data.utr) newErrors.utr = "UTR is required";

    if (!data.date) newErrors.date = "Date is required";
    if (!data.paymentMethod)
      newErrors.paymentMethod = "Payment Method is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${serverURL}/installationPartnerPayments/edit/${selectedRow._id}`,
        {
          amountPaid: data.amount,
          transactionId: data.utr,
          paymentDate: data.date,
          paymentMethod: data.paymentMethod,
          salaryCredited: true,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        handleCloseDialog();

        userListData();
      } else {
        console.error("Update Failed:", response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setData({
      amount: "",
      utr: "",
      date: "",
      paymentMethod: "",
    });
    setIsamount(true);
    onClose(); // Call the parent component's onClose function
  };

  const handleEdit = () => {
    setIsamount(false);
  };
  const handleSubmitEdit = () => {
    let error = {
      amount: false,
    };
    if (!data.amount) {
      error.amount = "Please Enter Amount";
      setErrors(error);
      return;
    } else {
      error.amount = false;
      setErrors(error);
      setIsamount(true);
      return;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleCloseDialog(); // Ensure data resets when closing
        }
      }}
      maxWidth="md"
      fullWidth
      BackdropProps={{
        sx: { backdropFilter: "blur(8px)" }, // Fix: Use `sx` instead of `style`
      }}
    >
      <DialogTitle className="flex justify-between items-center border-b p-4 font-semibold text-xl">
        IP Payment Update
        <IconButton onClick={handleCloseDialog} className="text-gray-500 ">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="p-6 md:space-y-4">
        <div className="flex flex-col md:flex-row md:m-2">
          <div className=" p-4 rounded-lg bg-gray-50 md:w-1/2 ">
            <div className="flex items-center space-x-4">
              <img
                src={
                  selectedRow?.installationPartnerId?.profilePhoto
                    ? selectedRow?.installationPartnerId?.profilePhoto
                    : "/assests/AdminDashboard/paymentipimage.png"
                }
                alt="User"
                className="w-12 h-12 md:w-28 md:h-28 rounded-md"
              />
              <div>
                <h2 className="md:text-3xl font-semibold">
                  {selectedRow?.installationPartnerId?.name || "N/A"}
                </h2>
                <p className="md:text-lg text-gray-500">
                  {selectedRow?.installationPartnerId?.phoneNumber || "N/A"}
                </p>
                <p className="text-xs md:text-sm bg-gray-200 inline-block px-3 py-1 rounded-full">
                  JOB ID : #{selectedRow?.jobId?._id?.slice(-6)}
                </p>
              </div>
            </div>
            <div className="flex space-x-2 mt-2">
              <Chip
                label={
                  selectedRow?.approvalStatus?.adminStatus == "1"
                    ? "Kam Approved"
                    : selectedRow?.approvalStatus?.adminStatus == "-1"
                      ? "Kam Rejected"
                      : "Pending By Kam"
                }
                sx={{
                  backgroundColor:
                    selectedRow?.approvalStatus?.adminStatus == "1"
                      ? "#DDFFD3" // Green for Approved
                      : selectedRow?.approvalStatus?.adminStatus == "-1"
                        ? "#FFCDD2" // Red for Rejected
                        : "#FFD98E", // Yellow for Pending
                  color:
                    selectedRow?.approvalStatus?.adminStatus == "1"
                      ? "#358C09"
                      : selectedRow?.approvalStatus?.adminStatus == "-1"
                        ? "#D32F2F"
                        : "#C77903",
                }}
              />
              <Chip
                label={
                  selectedRow?.approvalStatus?.clientStatus == "1"
                    ? "Client Approved"
                    : selectedRow?.approvalStatus?.clientStatus == "-1"
                      ? "Client Rejected"
                      : "Pending By Client"
                }
                sx={{
                  backgroundColor:
                    selectedRow?.approvalStatus?.clientStatus == "1"
                      ? "#DDFFD3" // Green for Approved
                      : selectedRow?.approvalStatus?.clientStatus == "-1"
                        ? "#FFCDD2" // Red for Rejected
                        : "#FFD98E", // Yellow for Pending
                  color:
                    selectedRow?.approvalStatus?.clientStatus == "1"
                      ? "#358C09"
                      : selectedRow?.approvalStatus?.clientStatus == "-1"
                        ? "#D32F2F"
                        : "#C77903",
                }}
              />
              {/* <span className="text-green-700 bg-green-200 px-2 py-1 rounded-full text-xs md:text-sm">KAM Approved</span> */}
              {/* <span className="text-red-700 bg-red-200 px-2 py-1 rounded-full text-xs md:text-sm">Client Disapproved</span> */}
            </div>
            <hr className="my-4" />
            <div className="">
              <h3 className="font-semibold">Campaign Name </h3>
              <p className="text-sm mb-4">
                {CapitaliseWords(selectedRow?.jobId?.campaignId?.campaignTitle)}
              </p>
              <h3 className="font-semibold">Address</h3>
              {/* <h4 className="font-semibold text-sm text-gray-500 my-1">Singhla Stores</h4> */}
              <p className="text-sm mb-4"> {selectedRow?.jobId?.address}</p>
              <h3 className="font-semibold">Job Date</h3>
              <p className="text-sm mb-4">
                {selectedRow?.jobId?.jobCompletionDate
                  ? new Date(
                      selectedRow?.jobId?.jobCompletionDate,
                    ).toLocaleDateString("en-GB")
                  : "N/A"}
              </p>
              <h3 className="font-semibold">Service</h3>
              <p className="text-sm mb-4">
                <HandymanOutlinedIcon />
                {selectedRow?.jobId?.serviceType == "0"
                  ? "Recce"
                  : "Installation"}
              </p>
            </div>
          </div>
          <div className="mx-6 md:w-1/2">
            <div className="mb-10">
              <div className="flex justify-between items-center">
                <h3
                  style={{
                    color: errors?.amount
                      ? "var(--error-color)"
                      : "var(--heading-color)",
                    fontFamily: "Helvetica",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    marginBottom: "8px",
                  }}
                >
                  Amount *
                </h3>
                <p
                  className={`cursor-pointer inline-flex items-center gap-1 ${
                    isamount
                      ? "text-[var(--primary-color)]"
                      : "text-[var(--para-color)]"
                  }`}
                  onClick={isamount ? handleEdit : undefined}
                >
                  <BorderColorOutlinedIcon fontSize="small" />
                  <span>Edit</span>
                </p>
              </div>
              <CustomInput
                name="amount"
                disabled={isamount}
                placeholder="Enter Amount"
                value={data.amount}
                size="small"
                type="number"
                error={!!errors?.amount}
                required
                onChange={(e) => {
                  handleInputChange(e);
                }}
                onFocus={(e) => {
                  e.target.addEventListener(
                    "wheel",
                    (event) => {
                      event.preventDefault();
                    },
                    { passive: false },
                  );
                }}
                onBlur={(e) => {
                  e.target.removeEventListener("wheel", (event) => {
                    event.preventDefault();
                  });
                }}
              />
              {errors?.amount && (
                <FormHelperText
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.amount}
                </FormHelperText>
              )}
            </div>
            <div className="mb-10">
              <h3
                style={{
                  color: errors?.utr
                    ? "var(--error-color)"
                    : "var(--heading-color)",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  marginBottom: "8px",
                }}
              >
                UTR *
              </h3>
              <CustomInput
                name="utr"
                disabled={!isamount}
                placeholder="Enter UTR"
                value={data.utr}
                size="small"
                error={!!errors?.utr}
                required
                onChange={(e) => {
                  handleInputChange(e);
                }}
                onFocus={(e) => {
                  e.target.addEventListener(
                    "wheel",
                    (event) => {
                      event.preventDefault();
                    },
                    { passive: false },
                  );
                }}
                onBlur={(e) => {
                  e.target.removeEventListener("wheel", (event) => {
                    event.preventDefault();
                  });
                }}
              />
              {errors?.utr && (
                <FormHelperText
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.utr}
                </FormHelperText>
              )}
            </div>
            <div className="mb-10">
              <h3
                style={{
                  color: errors?.date
                    ? "var(--error-color)"
                    : "var(--heading-color)",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  marginBottom: "8px",
                }}
              >
                Payment Date *
              </h3>
              <CustomInput
                name="date"
                placeholder="Enter date"
                disabled={!isamount}
                value={data.date}
                size="small"
                type="date"
                error={!!errors?.date}
                required
                onChange={(e) => {
                  handleInputChange(e);
                }}
              />
              {errors?.date && (
                <FormHelperText
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.date}
                </FormHelperText>
              )}
            </div>
            <div className="mb-10">
              <h3
                style={{
                  color: errors?.paymentMethod
                    ? "var(--error-color)"
                    : "var(--heading-color)",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                Payment Method *
              </h3>
              <FormControl
                label="State *"
                fullWidth
                disabled={!isamount}
                size="small"
                sx={{ marginTop: "0.5rem" }}
                error={errors?.paymentMethod}
                errorMessage={
                  errors?.paymentMethod ? (
                    <span style={{ color: "var(--error-color)" }}>
                      Please Enter Payment Method
                    </span>
                  ) : null
                }
                value={data?.paymentMethod}
              >
                <Select
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="paymentMethod"
                  value={data.paymentMethod}
                  onChange={handleInputChange}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <p className="text-[1rem] ">Enter Payment Method</p>
                      );
                    }

                    return selected;
                  }}
                >
                  {selectPaymentMethod.map((state) => (
                    <MenuItem key={state.name} value={state.name}>
                      {state.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors?.paymentMethod && (
                <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[6px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                  {errors?.paymentMethod}
                </p>
              )}
            </div>
            <div
              className={isamount ? "text-end" : "flex justify-between gap-3"}
            >
              {!isamount ? (
                <>
                  <GlobalButton
                    variant="secondary"
                    size="medium"
                    onClick={() => {
                      setIsamount(true);
                      setData({
                        amount: selectedRow?.amountPaid,
                      });
                    }}
                  >
                    {`Discard Changes`}
                  </GlobalButton>
                  <GlobalButton
                    variant="primary"
                    size="medium"
                    isLoading={isLoading}
                    onClick={() => handleSubmitEdit()}
                  >
                    {`Save Payment`}
                  </GlobalButton>
                </>
              ) : (
                <GlobalButton
                  variant="primary"
                  size="medium"
                  isLoading={isLoading}
                  onClick={handleSubmit}
                >
                  {`Submit Payment`}
                </GlobalButton>
              )}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDialog;
